(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-banner"] && !Shopify.designMode) return;
  try {
    
  /*
    Keep the marquee wider than the window.

    The track scrolls left by exactly half its own width and then snaps back,
    so for the loop to read as continuous each half has to be at least as wide
    as the visible area. With the three stock messages one set measures about
    847px, so on any window wider than that the tail ran out partway through
    and left blank space on the right. At 1440 that was roughly 70% of every
    18 second cycle, growing to a 592px gap before it snapped.

    The number of copies has to come from a measurement rather than a number
    typed into the template, because the messages are editable in the theme
    editor. A hardcoded count would break again the first time one is
    shortened, and it would break silently.
  */
  class MarqueeBanner extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.marquee-banner__track');
      if (!this.track) return;

      this.template = this.track.querySelector('.marquee-banner__set');
      if (!this.template) return;

      this.fill();

      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => this.fill());
        this.resizeObserver.observe(this);
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    fill() {
      const setWidth = this.template.getBoundingClientRect().width;
      const visible = this.clientWidth;
      if (!setWidth || !visible) return;

      // Sets per half, then doubled: the animation moves the track by 50% of
      // its own width, so the total must always be an even number of sets.
      const perHalf = Math.max(1, Math.ceil(visible / setWidth));
      const total = perHalf * 2;

      /*
        Hold the pixel speed constant.

        The animation always travels 50% of the track, so adding copies to
        fill a wider window also lengthens the distance covered in the same
        time. At 1440 that made it run twice as fast as the original two-set
        version and at 2560 four times, while mobile was unaffected because
        one set is already wider than the screen there. Scaling the duration
        by the same factor cancels it out.

        --marquee-speed therefore means seconds per set, not seconds per
        loop. With the stock messages one set is about 847px, so the default
        18s is roughly 47px per second at every window width.
      */
      const base = parseFloat(getComputedStyle(this).getPropertyValue('--marquee-speed')) || 18;
      this.track.style.animationDuration = base * perHalf + 's';

      const sets = this.track.querySelectorAll('.marquee-banner__set');
      if (sets.length === total) return;

      if (sets.length < total) {
        const fragment = document.createDocumentFragment();
        for (let i = sets.length; i < total; i++) {
          const clone = this.template.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('data-marquee-clone', '');
          fragment.appendChild(clone);
        }
        this.track.appendChild(fragment);
        return;
      }

      // Window got narrower. Drop clones only, never the two the template
      // rendered, so the no-JS floor survives.
      for (let i = sets.length - 1; i >= total; i--) {
        if (sets[i].hasAttribute('data-marquee-clone')) sets[i].remove();
      }
    }
  }

  customElements.define('marquee-banner', MarqueeBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-logos"] && !Shopify.designMode) return;
  try {
    
  /*
    The two sets the Liquid renders only loop seamlessly while one set is at
    least as wide as the visible strip. With the real logos a set is about
    832px, and the strip is the 1100px page width on desktop, so once the first
    set scrolled out the second could not cover the window and a gap of roughly
    270px rode across the row. This clones sets until half the track always
    covers the strip.

    Same approach as marquee-banner, with one addition: these sets are images,
    and a set measured before its logos have loaded is far too narrow, so the
    fill is re-run as they arrive.
  */
  class PressLogosMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.press-logos__track');
      this.template = this.querySelector('.press-logos__set');
      if (!this.track || !this.template) return;

      this.fill = this.fill.bind(this);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.fill);
        this.resizeObserver.observe(this);
      }

      this.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', this.fill, { once: true });
      });

      this.fill();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    fill() {
      const setWidth = this.template.getBoundingClientRect().width;
      const visible = this.clientWidth;
      if (!setWidth || !visible) return;

      // The animation travels 50% of the track, so the total must stay even.
      const perHalf = Math.max(1, Math.ceil(visible / setWidth));
      const total = perHalf * 2;

      /*
        Hold the pixel speed constant against BOTH variables: how wide the
        window is, and how many logos are in a set.

        Scaling only by the clone count fixes the first and misses the second.
        Adding three logos widened a set from 767px to about 1460px, and at a
        fixed 18s that took the strip from 43px/s to 81px/s, so simply adding a
        logo made the whole row visibly faster.

        So the duration is tied to the distance actually travelled, which is
        half the track. --marquee-speed is seconds per 800px of travel: at the
        default 18 that is roughly 44px/s at any window width and any number of
        logos, which is the pace the section was tuned to.
      */
      const REFERENCE_TRAVEL = 800;
      const base = parseFloat(getComputedStyle(this).getPropertyValue('--marquee-speed')) || 18;
      const halfTrack = setWidth * perHalf;
      this.track.style.animationDuration = (base * halfTrack / REFERENCE_TRAVEL) + 's';

      const sets = this.track.querySelectorAll('.press-logos__set');
      if (sets.length === total) return;

      if (sets.length < total) {
        const fragment = document.createDocumentFragment();
        for (let i = sets.length; i < total; i++) {
          const clone = this.template.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('data-marquee-clone', '');
          fragment.appendChild(clone);
        }
        this.track.appendChild(fragment);
        return;
      }

      // Narrower window: drop clones only, never the two the Liquid rendered,
      // so the no-JS floor survives.
      for (let i = sets.length - 1; i >= total; i--) {
        if (sets[i].hasAttribute('data-marquee-clone')) sets[i].remove();
      }
    }
  }

  if (!customElements.get('press-logos-marquee')) {
    customElements.define('press-logos-marquee', PressLogosMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
